<template>
  <div class="modal-card field-select-model">
    <header class="modal-card-head">
      <p class="modal-card-title is-centered">選擇匯出欄位</p>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <b-field label="選擇紀錄" horizontal grouped>
          <b-field>
            <b-select
              v-model="selectedConfigName"
              @input="selectConfig"
              placeholder="請選擇紀錄"
            >
              <option
                v-for="(option, index) in exportConfig"
                :value="option.name"
                :key="index"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <div class="control">
            <div class="buttons is-right">
              <b-button
                class="button is-primary"
                :disabled="!canAddConfig"
                @click.prevent="newConfig"
                >新增紀錄
              </b-button>
            </div>
          </div>
        </b-field>
        <b-field label="紀錄名稱" horizontal>
          <b-input v-model="configName" />
        </b-field>
      </div>
      <div class="columns">
        <div class="column is-5">
          <b-field>
            <b-select
              multiple
              native-size="10"
              v-model="wantedOptions"
              placeholder="請選擇欄位"
              class="field-select"
            >
              <option
                v-for="field in remainderFields"
                :value="field.id"
                :key="field.id"
              >
                {{ field.display_name }}
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="column is-2 margin-auto">
          <div class="columns is-centered">
            <div class="column has-text-centered">
              <b-button
                :disabled="wantedOptions.length === 0"
                @click.prevent="addFields"
                icon-left="arrow-right-bold"
              />
            </div>
          </div>
          <div class="columns is-centered">
            <div class="column has-text-centered">
              <b-button
                :disabled="removeOptions.length === 0"
                @click.prevent="removeFields"
                icon-left="arrow-left-bold"
              />
            </div>
          </div>
        </div>

        <div class="column is-5">
          <b-field>
            <b-select
              multiple
              native-size="10"
              v-model="removeOptions"
              placeholder="請選擇欄位"
              class="field-select"
            >
              <option
                v-for="field in selectedFields"
                :value="field.id"
                :key="field.id"
              >
                {{ field.display_name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <div style="width: 100%">
        <div class="buttons is-right">
          <button class="button" type="button" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </button>
          <button
            class="button is-primary"
            :disabled="!canSave"
            @click.prevent="onSave"
          >
            儲存
          </button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'SelectFieldsModel',

  props: {
    activityId: {
      type: Number,
      default: 0
    },
    exportConfig: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedConfigName: null,

      isNewConfig: false,
      configName: null,
      selectedFields: [],
      remainderFields: [],

      wantedOptions: [],
      removeOptions: []
    }
  },
  computed: {
    canAddConfig() {
      return this.exportConfig.length < 5
    },
    canSave() {
      return this.configName && this.selectedFields.length > 0
    }
  },
  watch: {
    exportConfig(exportConfig) {
      const config =
        exportConfig &&
        exportConfig.find(c => c.name === this.selectedConfigName)

      if (config) {
        this.selectedFields = this.mergeConfigFields(config)
      } else {
        this.selectedFields = []
      }
    }
  },
  mounted() {
    const config = this.exportConfig && this.exportConfig[0]

    if (config) {
      this.selectedConfigName = config.name
      this.configName = config.name
      this.selectedFields = this.mergeConfigFields(config)
    } else {
      this.selectedConfigName = 'default'
      this.configName = 'default'
      this.selectedFields = []
    }

    this.updatedRemainderFields()
  },
  methods: {
    mergeConfigFields(config) {
      let fields = []

      config.fields.forEach(f => {
        const field = this.fields.find(
          field =>
            f.class_type === field.class_type &&
            f.property_name === field.property_name
        )

        if (field) {
          fields.push({
            ...field,
            alias_name: f.alias_name
          })
        }
      })

      return fields
    },
    newConfig() {
      this.isNewConfig = true
      this.configName = ''
      this.selectedFields = []
      this.updatedRemainderFields()
    },
    selectConfig(configName) {
      const config =
        this.exportConfig && this.exportConfig.find(c => c.name === configName)

      this.isNewConfig = false
      this.configName = config.name
      this.selectedFields = this.mergeConfigFields(config)
      this.updatedRemainderFields()
    },
    addFields() {
      const fields = this.fields.filter(field => {
        return this.wantedOptions.includes(field.id)
      })

      this.selectedFields = [...this.selectedFields, ...fields]
      this.updatedRemainderFields()

      this.wantedOptions = []
    },
    removeFields() {
      this.selectedFields = this.selectedFields.filter(field => {
        return !this.removeOptions.includes(field.id)
      })

      this.updatedRemainderFields()

      this.removeOptions = []
    },
    updatedRemainderFields() {
      this.remainderFields = this.fields.filter(field => {
        return this.selectedFields.findIndex(f => f.id === field.id) === -1
      })
    },
    async onSave() {
      if (!this.canSave) {
        return
      }

      const fields = this.selectedFields.map(f => ({
        class_type: f.class_type,
        property_name: f.property_name,
        alias_name: f.alias_name
      }))

      let exportConfig = []
      let index = -1

      if (!this.isNewConfig) {
        index = this.exportConfig.findIndex(
          c => c.name === this.selectedConfigName
        )
      }

      if (index === -1) {
        exportConfig = [...this.exportConfig, { name: this.configName, fields }]
      } else {
        exportConfig = [
          ...this.exportConfig.slice(0, index),
          { name: this.configName, fields },
          ...this.exportConfig.slice(index + 1)
        ]
      }

      this.$emit('save-fields', exportConfig)
    }
  }
}
</script>

<style lang="scss">
.field-select-model {
  .field {
    height: 100%;

    .field-select {
      height: 100%;

      .select {
        width: 100%;
        height: 100%;

        select {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .margin-auto {
    margin: auto;
  }
}
</style>
